import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';
import {Znamka} from '../model/znamka';
import {Config} from '../model/Config';
import {MatDialog} from '@angular/material/dialog';
import {StudijnyPlanComponent} from '../studijny-plan/studijny-plan.component';
import { HttpClient } from '@angular/common/http';
import {StudijnyPlan} from '../model/StudijnyPlan';
import {CastStudijnehoPlanu} from '../model/CastStudijnehoPlanu';
import {PredmetySection} from '../model/PredmetySection';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-znamky',
    templateUrl: './znamky.component.html',
    styleUrls: ['./znamky.component.css'],
    standalone: false
})
export class ZnamkyComponent implements OnInit, OnDestroy {
  red: boolean;
  sections: PredmetySection[];

  constructor(
    private appService: AppService,
    private dialogService: MatDialog,
    private http: HttpClient,
    private translation: TranslateService
  ) {

  }

  znamky: Znamka[] = [];
  castiSP: CastStudijnehoPlanu[] = [];
  znamkySubscription: Subscription;

  public config: Config;

  private configLoader = new Subscription();

  spinner = false;

  ngOnInit(): void {
    // subscriptions

    this.znamkySubscription = this.appService.znamkySubject
        .subscribe(
            (predmety) => {
                this.znamky = predmety.znamky;
                this.castiSP = predmety.castiStudijnehoPlanu;
                this.processZnamky(this.znamky);
            });

    this.configLoader = this.appService.configLoader
        .subscribe((config) => {
            this.config = config;
        });

    this.znamky = this.appService.getZnamky();
    this.castiSP = this.appService.getCastiSP();
    this.config = this.appService.getConfig();
    this.red = this.appService.getRed();

    this.processZnamky(this.znamky);
  }

  ngOnDestroy(): void {
    this.znamkySubscription.unsubscribe();
    this.configLoader.unsubscribe();
  }

  private processZnamky(znamky: Znamka[])
  {
    this.sections = [];

    if (this.castiSP) {
      this.castiSP.forEach(
        cast => {
          const predmetySection = this.createPredmetySection(cast, znamky);
          this.sections.push(predmetySection);
        });
    }

  }

  openStudijnyPlan(): void {

    this.spinner = true;

    const zl = this.appService.getZapisnyListSelected();

    this.http.get<StudijnyPlan>(
      '/ais/rest/portal/student-predmety/studijny-plan/' + zl.id
    ).subscribe({
        next: (studijnyPlan) => {
          this.spinner = false;
          if (this.dialogService.openDialogs.length === 0) {
            const dialogRef = this.dialogService.open(
              StudijnyPlanComponent, {
                data: {
                  studijnyPlan
                },
                width: window.innerWidth <= 768 ? '99%' : '50%',
                minHeight: '50%',
              });
          }
        },
        error: (error) => {
          this.spinner = false;
          console.error(error);
        }
      });
  }

  private getZnamkyBySection(cast: CastStudijnehoPlanu, znamky: Znamka[]) {
    if (znamky) {
      return znamky.slice().filter(i => (i.kodCastSP === cast.castKod && (i.kodTypVyucby === cast.typKod || cast.typKod === null)));
    }
    return [];
  }

  private createPredmetySection(cast: CastStudijnehoPlanu, znamky: Znamka[]): PredmetySection
  {
    const predmetySection = new PredmetySection();
    predmetySection.castSp = cast.castPopis;
    predmetySection.typVyucby = cast.typPopis;
    predmetySection.kredit = 0;
    predmetySection.kreditZiskany = 0;
    predmetySection.predmety = this.getZnamkyBySection(cast, znamky);
    predmetySection.predmety.forEach(
      p => {
        predmetySection.kredit += p.kredit;
        if (p.hodnotenieKod && p.zapocitat && p.hodnotenieKod !== 'X' && p.fazaFinal) {
          predmetySection.kreditZiskany += p.kredit;
        }
      });

    predmetySection.castSpKod = cast.castKod;
    predmetySection.typVyucbyKod = cast.typKod;

    return predmetySection;
  }

    openElektronickyZapis()
    {
        const zl = this.appService.getZapisnyList(this.config.elZapisAkRok);

        if (zl !== null) {
            window.location.href = '/ais/apps/zapis/' + this.translation.currentLang.toLowerCase() +
                '?studium=' + this.config.idStudium + '&zl=' + zl.id;
        }
    }

    get hasZapisnyListForElZapisAkRok(): boolean
    {
        const zl = this.appService.getZapisnyList(this.config.elZapisAkRok);
        return zl !== null && zl.elZapis === true;
    }
}
